// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrelandCardSelector__wrapper--fx7LO {
    position: relative;
}

    @media screen and (min-width: 1024px) {.PrelandCardSelector__wrapper--fx7LO {
        overflow: hidden;
        padding-bottom: 12px
}
    }

.PrelandCardSelector__cards--gWvjC {
    position: relative;
    width: 218px;
    height: 340px;
    margin: 20px auto;
}

.PrelandCardSelector__card--RpHRP {
    position: absolute;
    cursor: pointer;
}

.PrelandCardSelector__backgroundImage--CLh34 {
    background-repeat: no-repeat;
    background-size: contain;
    width: 218px;
    height: 340px;
    position: relative;
    transition: transform 0.25s ease-in-out, filter 0.15s ease-in-out;
    will-change: transfrom;
    border-radius: 9px;
}

.PrelandCardSelector__cardInformation--bF8ki {
    margin: 0 auto;
    max-width: 360px;
    margin-bottom: 12px;
    width: 100%;
    margin-top: 55px;
}

@media screen and (max-width: 1023px) {

.PrelandCardSelector__cardInformation--bF8ki {
        margin-top: 16px
}
    }

@media screen and (min-width: 1024px) {

.PrelandCardSelector__cardInformation--bF8ki {
        padding: 0 24px
}
    }

.PrelandCardSelector__teamRoleScore--Elbwh {
    position: absolute;
    bottom: 8px;
    left: 50%;
    z-index: 20;
    font-size: 36px;
    font-style: italic;
    font-weight: 700;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.45);
    transform: rotate(-8deg) translateX(-50%);
    text-align: center;
    display: inline-flex;
    align-items: center;
}

.PrelandCardSelector__teamRoleScore--Elbwh.PrelandCardSelector__high--YzmAC {
        color: #5A9735;
    }

.PrelandCardSelector__teamRoleScore--Elbwh.PrelandCardSelector__medium--boywy {
        color: #FFD370;
    }

.PrelandCardSelector__teamRoleScore--Elbwh.PrelandCardSelector__low--tyhem {
        color: #FF5166;
    }

.PrelandCardSelector__teamRoleScore--Elbwh .PrelandCardSelector__maxNumberText--J70k7 {
        color: #FFA300;
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.45);
        font-size: 9px;
        margin-left: 4px;
        font-style: italic;
        font-weight: 700;
        text-transform: uppercase;
    }

.PrelandCardSelector__cardInformationItem--Db5_O {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(255, 255, 255, 0.6);
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.PrelandCardSelector__cardInformationItemIndicator--XuZRI {
    margin-bottom: 4px;
}

.PrelandCardSelector__buttonCheck--uj1sG,
.PrelandCardSelector__buttonClose--qxhZh {
    position: absolute;
    z-index: 20;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    padding: 8px;
    cursor: pointer;
    border: none;
    background-color: #464D65;
    --icon-size: 24px;
}

@media (hover: hover) and (pointer: fine) {
            .PrelandCardSelector__buttonCheck--uj1sG:hover svg, .PrelandCardSelector__buttonClose--qxhZh:hover svg {
                color: var(--secondary-color);
            }
    }

.PrelandCardSelector__buttonCheck--uj1sG:active svg, .PrelandCardSelector__buttonClose--qxhZh:active svg {
            color: var(--dark-secondary-new-color);
        }

.PrelandCardSelector__buttonCheck--uj1sG.PrelandCardSelector__disabled--lPIiJ, .PrelandCardSelector__buttonClose--qxhZh.PrelandCardSelector__disabled--lPIiJ {
        pointer-events: none;
    }

.PrelandCardSelector__buttonCheck--uj1sG.PrelandCardSelector__preview--RtZ4U, .PrelandCardSelector__buttonClose--qxhZh.PrelandCardSelector__preview--RtZ4U {
        padding: 4px;
        position: static;
        z-index: 1;
        transform: none;
    }

.PrelandCardSelector__buttonClose--qxhZh {
    left: 0px;
}

.PrelandCardSelector__buttonClose--qxhZh svg {
        color: var(--warning-color);
    }

.PrelandCardSelector__buttonCheck--uj1sG {
    right: 0px;
}

.PrelandCardSelector__buttonCheck--uj1sG svg {
        color: var(--approved-color);
    }
`, "",{"version":3,"sources":["webpack://./src/components/Plelander/PrelandCardSelector/PrelandCardSelector.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AAMtB;;IAJI,uCAHJ;QAIQ,gBAAgB;QAChB;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iEAAiE;IACjE,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AASpB;;AAPI;;AAPJ;QAQQ;AAMR;IALI;;AAEA;;AAXJ;QAYQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,yCAAyC;IACzC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AAuBvB;;AArBI;QACI,cAAc;IAClB;;AAEA;QACI,cAAc;IAClB;;AAEA;QACI,cAAc;IAClB;;AAEA;QACI,cAAc;QACd,0CAA0C;QAC1C,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;IAC7B;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AA0BrB;;AAxBI;YAEQ;gBACI,6BAA6B;YACjC;IAER;;AAGI;YACI,sCAAsC;QAC1C;;AAGJ;QACI,oBAAoB;IACxB;;AAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,UAAU;QACV,eAAe;IACnB;;AAGJ;IACI,SAAS;AAKb;;AAHI;QACI,2BAA2B;IAC/B;;AAGJ;IACI,UAAU;AAKd;;AAHI;QACI,4BAA4B;IAChC","sourcesContent":[".wrapper {\n    position: relative;\n\n    @media (--large) {\n        overflow: hidden;\n        padding-bottom: 12px;\n    }\n}\n\n.cards {\n    position: relative;\n    width: 218px;\n    height: 340px;\n    margin: 20px auto;\n}\n\n.card {\n    position: absolute;\n    cursor: pointer;\n}\n\n.backgroundImage {\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 218px;\n    height: 340px;\n    position: relative;\n    transition: transform 0.25s ease-in-out, filter 0.15s ease-in-out;\n    will-change: transfrom;\n    border-radius: 9px;\n}\n\n.cardInformation {\n    margin: 0 auto;\n    max-width: 360px;\n    margin-bottom: 12px;\n    width: 100%;\n    margin-top: 55px;\n\n    @media (--mobile) {\n        margin-top: 16px;\n    }\n\n    @media (--large) {\n        padding: 0 24px;\n    }\n}\n\n.teamRoleScore {\n    position: absolute;\n    bottom: 8px;\n    left: 50%;\n    z-index: 20;\n    font-size: 36px;\n    font-style: italic;\n    font-weight: 700;\n    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.45);\n    transform: rotate(-8deg) translateX(-50%);\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n\n    &.high {\n        color: #5A9735;\n    }\n\n    &.medium {\n        color: #FFD370;\n    }\n\n    &.low {\n        color: #FF5166;\n    }\n\n    .maxNumberText {\n        color: #FFA300;\n        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.45);\n        font-size: 9px;\n        margin-left: 4px;\n        font-style: italic;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n}\n\n.cardInformationItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 16px;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n}\n\n.cardInformationItemIndicator {\n    margin-bottom: 4px;\n}\n\n.buttonCheck,\n.buttonClose {\n    position: absolute;\n    z-index: 20;\n    top: 50%;\n    transform: translateY(-50%);\n    border-radius: 50%;\n    padding: 8px;\n    cursor: pointer;\n    border: none;\n    background-color: #464D65;\n    --icon-size: 24px;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            svg {\n                color: var(--secondary-color);\n            }\n        }\n    }\n\n    &:active {\n        svg {\n            color: var(--dark-secondary-new-color);\n        }\n    }\n\n    &.disabled {\n        pointer-events: none;\n    }\n\n    &.preview {\n        padding: 4px;\n        position: static;\n        z-index: 1;\n        transform: none;\n    }\n}\n\n.buttonClose {\n    left: 0px;\n\n    svg {\n        color: var(--warning-color);\n    }\n}\n\n.buttonCheck {\n    right: 0px;\n\n    svg {\n        color: var(--approved-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PrelandCardSelector__wrapper--fx7LO`,
	"cards": `PrelandCardSelector__cards--gWvjC`,
	"card": `PrelandCardSelector__card--RpHRP`,
	"backgroundImage": `PrelandCardSelector__backgroundImage--CLh34`,
	"cardInformation": `PrelandCardSelector__cardInformation--bF8ki`,
	"teamRoleScore": `PrelandCardSelector__teamRoleScore--Elbwh`,
	"high": `PrelandCardSelector__high--YzmAC`,
	"medium": `PrelandCardSelector__medium--boywy`,
	"low": `PrelandCardSelector__low--tyhem`,
	"maxNumberText": `PrelandCardSelector__maxNumberText--J70k7`,
	"cardInformationItem": `PrelandCardSelector__cardInformationItem--Db5_O`,
	"cardInformationItemIndicator": `PrelandCardSelector__cardInformationItemIndicator--XuZRI`,
	"buttonCheck": `PrelandCardSelector__buttonCheck--uj1sG`,
	"buttonClose": `PrelandCardSelector__buttonClose--qxhZh`,
	"disabled": `PrelandCardSelector__disabled--lPIiJ`,
	"preview": `PrelandCardSelector__preview--RtZ4U`
};
export default ___CSS_LOADER_EXPORT___;
